import { render, staticRenderFns } from "./MeasuringUnitsTable.vue?vue&type=template&id=2e6b176e"
import script from "./MeasuringUnitsTable.vue?vue&type=script&lang=ts"
export * from "./MeasuringUnitsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports